import { Alert, Button } from "@mui/material";
import { useDisclosedNamesMapQuery } from "Api/Queries/Social/useDisclosedNamesMapQuery";
import { Resources, useResource } from "Translations/Resources";

/**
 * The disclosed-names map upgrades @handles to real names (ADR-0007). When it cannot be loaded,
 * chat still works but every private person shows as @handle — said out loud, with a retry,
 * rather than left to look like the rule changed. Renders nothing while the map is fine.
 * (Sentry already gets the error via the global query cache handler.)
 */
export const ChatDisclosedNamesAlert = () => {
  const { t } = useResource();
  const { isError, refetch, isFetching } = useDisclosedNamesMapQuery();

  if (!isError) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      action={
        <Button
          color="inherit"
          size="small"
          disabled={isFetching}
          onClick={() => refetch()}
        >
          {t(Resources.Common.Retry)}
        </Button>
      }
    >
      {t(Resources.Chat.DisclosedNamesUnavailable)}
    </Alert>
  );
};
